import React from "react"
import ThemeProvider from "@material-ui/styles/ThemeProvider"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import SportsTrainingPost from "../../../components/sports-training-post"
import theme from "../../../theme"

const summary = [
  {
    level: "Beginner",
    frequency: "2 to 3 pool sessions",
    focus: "Water confidence, breathing, body position, kicking, basic strokes",
    weeklyHabit: "Keep technique relaxed and stop before fatigue changes form",
  },
  {
    level: "Developing swimmer",
    frequency: "3 pool sessions",
    focus: "Freestyle, backstroke, breaststroke basics, turns, rhythm",
    weeklyHabit: "Use short repeats with plenty of technique cues",
  },
  {
    level: "Competitive swimmer",
    frequency: "4 to 6 sessions",
    focus: "Starts, turns, pacing, stroke efficiency, race skills",
    weeklyHabit: "Track split times and one technical focus each session",
  },
  {
    level: "Advanced swimmer",
    frequency: "6 sessions with recovery",
    focus: "Training blocks, strength, mobility, race plans, tapering",
    weeklyHabit: "Schedule hard, moderate, easy, and recovery days clearly",
  },
]

const sections = [
  {
    title: "Beginner: feel safe and balanced",
    paragraphs: [
      "Beginner swimming training should build water confidence, floating, breathing, kicking, and relaxed body position before chasing speed.",
      "Short repeats are best. If technique starts to collapse, rest or change the task rather than pushing through messy laps.",
    ],
  },
  {
    title: "Developing swimmer: improve stroke rhythm",
    paragraphs: [
      "Developing swimmers can practise freestyle, backstroke, breaststroke basics, turns, and simple kick or pull sets. Each session should have one clear technique focus.",
      "Breathing rhythm matters. Many swimmers improve quickly when they slow down enough to keep body position stable while breathing.",
    ],
  },
  {
    title: "Competitive swimmer: train race skills",
    paragraphs: [
      "Competitive swimmers need starts, turns, pacing, streamlines, stroke efficiency, and race-specific sets. Not every lap needs to be hard, but every lap should have a purpose.",
      "Use split times, stroke counts, or effort ratings to learn pacing instead of guessing how fast the swimmer is moving.",
    ],
  },
  {
    title: "Advanced swimmer: organise the training block",
    paragraphs: [
      "Advanced swimming routines should separate endurance, speed, race pace, strength, mobility, recovery, and tapering. Load needs to be planned across the week, not decided day by day.",
      "A shared calendar helps families track early sessions, school demands, meets, dryland training, and rest so the swimmer arrives ready rather than drained.",
    ],
  },
]

const SwimmingTrainingRoutines = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <SEO
        title="Swimming Training Schedule by Skill Level"
        description="Plan swimming training for beginners through advanced swimmers with routines for technique, breathing, pacing, race skills, and recovery."
      />
      <SportsTrainingPost
        sport="Swimming"
        title="Swimming training routines for different levels"
        intro="A useful swimming routine protects technique first, then builds endurance, speed, race skills, and recovery around that efficient movement."
        sharedCalendarUrl="https://app.schoolcalendar.me/calendar/tasty-bullfrog-21"
        image="blog-swimming.png"
        imageAlt="Swimming training planning"
        summary={summary}
        sections={sections}
      />
    </Layout>
  </ThemeProvider>
)

export default SwimmingTrainingRoutines
